import { Checkbox } from "@graffer-inc/console-design-kit";

type ApplicationRemovalTaskCheckProps = {
  title: string;
  checkboxLabel: string;
  description: React.ReactNode;
  value: boolean;
  onChange: (value: boolean) => void;
};

export const ApplicationRemovalTaskCheck: React.FC<
  ApplicationRemovalTaskCheckProps
> = ({ title, checkboxLabel, description, value, onChange }) => {
  return (
    <>
      <h2 className="has-text-weight-bold mt-4">{title}</h2>
      {description}
      <Checkbox
        label={""}
        options={[
          {
            value: "agree",
            name: checkboxLabel,
          },
        ]}
        values={value ? ["agree"] : []}
        description={""}
        required
        onChange={(e) => {
          onChange(e.target.checked);
        }}
      />
    </>
  );
};
